import { createSelector } from 'reselect';
import { getLatestActivityType } from 'lib/selectors/getLatestActivityType';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';

const getLatestActivityMode = createSelector(
  [getLatestActivityType, getCurrentLaborTicket, getPostLaborUpdatesOnNats],
  (latestActivityType, currentLaborTicket, natsFlowEnabled) => {
    // In async flow, labor ticket type is the source of truth for activity mode
    if (natsFlowEnabled && currentLaborTicket?.type) {
      return currentLaborTicket.type;
    }

    // Standard flow: get from activity type
    if (!latestActivityType) {
      return null;
    }
    return latestActivityType.activityMode;
  }
);

export { getLatestActivityMode };
